const enableDebugMessages = JSON.parse(process.env.VUE_APP_DEBUG_MESSAGES)
export default {
  apiUrl: process.env.VUE_APP_API_URL,
  // apiUrl: "https://api.starlinebus-egypt.com",
  agentHubUrl: process.env.VUE_APP_AGENT_HUB_URL,
  // agentHubUrl: "https://api.starlinebus-egypt.com/hubs/agenthub",
  apiDebugMessages: enableDebugMessages
}